import { render } from "./AdminUsersAdd.vue?vue&type=template&id=928705de"
import script from "./AdminUsersAdd.vue?vue&type=script&lang=js"
export * from "./AdminUsersAdd.vue?vue&type=script&lang=js"

import "./AdminUsersAdd.vue?vue&type=style&index=0&id=928705de&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__